import {EState} from '@app/state/reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ICookiePolicyState} from '../models/cookie-policy-state.model';

export const selectCookiePolicyState = createFeatureSelector<ICookiePolicyState>(EState.CookiePolicy);
export const selectCookiePolicyStatus = createSelector(selectCookiePolicyState, (state: ICookiePolicyState) => state);
export const selectShowConsentStatus = createSelector(
  selectCookiePolicyState,
  (state: ICookiePolicyState) => state?.showConsentDialog
);
